export const getStepNavData = store => {
  return store.nav;
}
